<template>
    <rkm-modal
        extra-large
        persistent
        ref="RkmModal"
        title="Agendamentos"
    >
        <rkm-area
            v-for="(paciente, i) in pacientes"
            :key="i"
            type="fieldset"
        >
            O paciente <strong>{{ paciente.agendamentos[0].pacienteNome }}</strong> possui o(s) seguinte(s) agendamento(s):<br><br>

            <rkm-table
                :fields="fields"
                :items="paciente.agendamentos"
                hide-filters
                hide-pagination
                sort-by="text"
            />
        </rkm-area>

        <br>

        Deseja confirmar a alteração neste(s) paciente(s)?

        <template v-slot:footer>
            <rkm-button
                @click="confirm"
                color="primary"
            >
                Sim
            </rkm-button>

            <rkm-button @click="close">
                Não
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {formats} from '@/mixins'

// Others.
import moment from 'moment'

export default {
    data() {
        return {
            fields: [
                {key: 'data', label: 'Data viagem', formatter: v => this.formatDate(v), sortable: true},
                {key: 'motivo', label: 'Motivo', sortable: true},
                {key: 'municipio', label: 'Município', sortable: true},
                {key: 'destino', label: 'Local consulta', sortable: true},
                {key: 'horario', label: 'Horário', sortable: true},
                {key: 'veiculo', label: 'Veículo', sortable: true},
                {key: 'jornadaDescricao', label: 'Jornada', sortable: true},
                {key: 'observacao', label: 'Observação'},
            ],
            pacientes: [],
            onClose: null,
            others: { moment },
        }
    },
    methods: {
        open(pacientes, onClose) {
            this.pacientes = pacientes.map(paciente => {
                paciente.agendamentos = paciente.agendamentos.map(item => ({
                    pacienteNome: item.pacienteNome,
                    data: this.others.moment(item.data, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                    motivo: item.motivo,
                    municipio: item.municipio,
                    destino: item.destino,
                    horario: item.horario,
                    veiculo:  `${item.numeroPlaca} - ${item.descricaoModelo}`,
                    jornadaDescricao: item.jornadaDescricao,
                    observacao: item.observacao,
                }))

                return paciente
            })

            this.onClose = onClose

            this.$refs.RkmModal.show()
        },
        confirm() {
            this.pacientes.forEach(paciente => {
                paciente.onConfirm()
            })

            this.close()
        },
        close() {
            this.onClose()
            this.$refs.RkmModal.hide()
        }
    },
    mixins: [formats],
}
</script>